<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.prefatdes_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Documentos
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.prefatdes_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Número Fiscal</th>
                <th style="width: 5%">Série</th>
                <th style="width: 10%">Data de emissão</th>
                <th style="width: 5%">Valor</th>
                <th style="width: 10%">Tipo do Documento</th>
                <th style="width: 10%">Cód Tabela de Frete</th>
                <th style="width: 20%">Origem</th>
                <th style="width: 20%">Destino</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in rowData.pre_fatura_despesa_doc">
                <tr>
                  <td>
                    {{ item.doc_transp[0].num_doc }}
                  </td>
                  <td>
                    {{ item.doc_transp[0].serie }}
                  </td>
                  <td>
                    <span>
                      {{ DateFormat(item.doc_transp[0].dt_emissao) }}
                    </span>
                  </td>
                  <td>
                    {{
                      item.doc_transp[0].doc_transp_vlr_prestacao.vlr_receber
                    }}
                  </td>
                  <td>
                    {{ item.doc_transp[0].liv_tp_doc.descr }}
                  </td>
                  <td>
                    <span
                      v-if="
                        item.doc_transp[0].doc_transp_docfis != null &&
                        item.doc_transp[0].doc_transp_docfis
                          .tabela_frete_rota_vig != null
                      "
                    >
                      {{
                        item.doc_transp[0].doc_transp_docfis
                          .tabela_frete_rota_vig.tabela_frete_rota.tabela_frete
                          .cd
                      }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="
                       item.doc_transp[0].doc_transp_docfis != null &&
                        item.doc_transp[0].doc_transp_docfis
                          .tabela_frete_rota_vig != null &&
                        item.doc_transp[0].doc_transp_docfis
                          .tabela_frete_rota_vig.tabela_frete_rota
                          .municipio_origem != null
                      "
                    >
                      {{
                        item.doc_transp[0].doc_transp_docfis
                          .tabela_frete_rota_vig.tabela_frete_rota
                          .municipio_origem.nome
                      }}
                    </span>
                    <span
                      v-if="
                       item.doc_transp[0].doc_transp_docfis != null &&
                        item.doc_transp[0].doc_transp_docfis
                          .tabela_frete_rota_vig != null &&
                        item.doc_transp[0].doc_transp_docfis
                          .tabela_frete_rota_vig.tabela_frete_rota
                          .regiao_origem != null
                      "
                    >
                      {{
                        item.doc_transp[0].doc_transp_docfis
                          .tabela_frete_rota_vig.tabela_frete_rota.regiao_origem
                          .descr
                      }}
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="
                       item.doc_transp[0].doc_transp_docfis != null &&
                        item.doc_transp[0].doc_transp_docfis
                          .tabela_frete_rota_vig != null &&
                        item.doc_transp[0].doc_transp_docfis
                          .tabela_frete_rota_vig.tabela_frete_rota
                          .municipio_destino != null
                      "
                    >
                      {{
                        item.doc_transp[0].doc_transp_docfis
                          .tabela_frete_rota_vig.tabela_frete_rota
                          .municipio_destino.nome
                      }}
                    </span>
                    <span
                      v-if="
                       item.doc_transp[0].doc_transp_docfis != null &&
                        item.doc_transp[0].doc_transp_docfis
                          .tabela_frete_rota_vig != null &&
                        item.doc_transp[0].doc_transp_docfis
                          .tabela_frete_rota_vig.tabela_frete_rota
                          .regiao_destino != null
                      "
                    >
                      {{
                        item.doc_transp[0].doc_transp_docfis
                          .tabela_frete_rota_vig.tabela_frete_rota
                          .regiao_destino.descr
                      }}
                    </span>
                  </td>

                  <td>
                    <a
                      v-if="item.doc_transp[0].doc_transp_docfis != null"
                      @click="onDetail(item.prefatdesdoc_id)"
                      v-b-tooltip
                      title="Ver Notas"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="isVisibleDetail(item.prefatdesdoc_id)">
                  <td colspan="9">
                    <section class="tabs-section">
                      <div class="tab-content">
                        <div
                          role="tabpanel"
                          class="
                            tab-pane
                            fade
                            in
                            active
                            show
                            pt-1
                            border-color-detalhes-grey
                          "
                          v-bind:id="'tr1' + item.prefatdesdoc_id + ''"
                        >
                          <table
                            :class="[
                              'vuetable table table-striped tbl-typical',
                            ]"
                          >
                            <thead>
                              <tr>
                                <th style="width: 25%">N° Fiscal</th>
                                <th style="width: 15%">Série</th>
                                <th style="width: 25%">Data de Emissão</th>
                                <th style="width: 35%">Chave</th>
                              </tr>
                            </thead>
                            <tbody v-for="(item_itens, i) in item.doc_transp">
                              <tr
                                class="bg-gray-light"
                                style="display: table-row"
                              >
                                <td>
                                  {{
                                    item_itens.doc_transp_docfis.doc_fiscal
                                      .num_fiscal
                                  }}
                                </td>
                                <td>
                                  {{
                                    item_itens.doc_transp_docfis.doc_fiscal
                                      .serie
                                  }}
                                </td>
                                <td>
                                  {{
                                    DateFormat(
                                      item_itens.doc_transp_docfis.doc_fiscal
                                        .dt_emissao
                                    )
                                  }}
                                </td>
                                <td>
                                  {{
                                    item_itens.doc_transp_docfis.doc_fiscal
                                      .chave
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </section>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>

  <script>
import moment from "moment";

export default {
  data() {
    return {
      visibleDetailRows: [],
      helpForm: new Form({ recordCollection: [], status: "" }),
      cnpj_formatado: "",
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onEditDoc(data) {
      this.$refs.vinculardocumentounidadeform.onEdit(data);
    },
    onEditConta(data) {
      this.$refs.vincularcontaunidadeform.onEdit(data);
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;onDetail
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.unidoc_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.vinculardocumentounidadeform.onActivateDesactivate(
        this.helpForm
      );
    },
    onDetail(prefatdesdoc_id) {
      this.toggleDetail(prefatdesdoc_id);
    },
    isVisibleDetail(rowId) {
      // console.log(rowID);
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetail(rowId) {
      if (!this.isVisibleDetail(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetail(rowId) {
      if (this.isVisibleDetail(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetail(rowId) {
      if (this.isVisibleDetail(rowId)) {
        this.hideDetail(rowId);
      } else {
        this.showDetail(rowId);
      }
    },
  },
};
</script>
